<template>
  <Portal to="tooltips">
    <tooltip :pointer="true" :width="'auto'" :delay="800" />
  </Portal>
</template>

<script>
export default {
  name: "Sidebar",
};
</script>

<style lang="scss" scoped>
@import "@/core/themes/partials/_utils.scss";
@import "@/core/themes/partials/_tooltips.scss";

.sidebar {
  position: fixed;
  margin-top: 60px;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  background-color: #151617;
  border-top: solid 1px $dark8;
  display: flex;
  flex-direction: column;
  @include trans-all;
  z-index: 49;
  padding: 8px;
  .noHover {
    pointer-events: none;
  }
  > a,
  > a:visited {
    color: $textDarkModeLowContrast;
  }
  > a:hover {
    color: $textDarkModeHigh;
    background-color: $dark5;
  }
  > a:first-child:hover {
    background-color: $dark2;
  }
  .logo {
    // width: calc(100%);
    padding: 11px 16px;
    height: 40px;
    display: flex;
    border-radius: $radius;
    .icon {
      margin-right: 8px;
      font-size: 16px;
    }
    &__text {
      color: $textDarkModeLowContrast;
      line-height: 22px !important;
    }
  }
  .logo-agency {
    padding: 16px;
  }

  section.account-container {
    max-height: 120px;
    background: $dark4;
    position: relative;
    margin-top: auto;
    margin-bottom: 60px;
    border-top: solid 1px $dark8;
    .account {
      // height: 100%;
      width: 100%;
    }
  }

  .sidenav {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    // width: calc(100% + 2px);
    margin-left: -8px;
    margin-right: -8px;

    .pages {
      margin-bottom: 16px;
    }

    .help-center {
      margin-top: auto;

      .gp_dropdown {
        &_list {
          top: unset;
          bottom: 100%;
          right: -16px;
        }
      }
    }

    .acc-nav {
      margin-bottom: 19px;
    }

    .nav-link {
      padding: 9.5px 16px;
      display: flex;
      position: relative;
      flex-direction: row;
      align-items: center;
      font-weight: 500;
      text-decoration: none;
      @include trans-all;
      @include no-select;
      border-radius: $radius;

      &__quick-add {
        padding: 0;
        $size: 32px;
        width: $size;
        height: $size;
        background: inherit;
        margin-left: auto;
        display: none;
        z-index: 10;
        position: absolute;
        top: calc(50% - calc($size / 2));
        right: 8px;
        .icon {
          top: unset !important;
          font-size: 20px !important;
          line-height: 20px !important;
        }
        &:hover {
          background: $dark5;
        }
      }

      &.rl-active {
        .nav-link__quick-add {
          &:hover {
            background: $dark8;
          }
        }
      }

      .text-item {
        height: 21px;
        font-size: 14px;
        line-height: 21px;
      }

      &:not(.disabled) {
        color: #e2e2e2;
      }

      &.disabled {
        color: $textDarkModeDisabled !important;
        i.icon {
          color: $textDarkModeDisabled !important;
        }
        &.open .arrow i.icon {
          color: $textDarkModeDisabled !important;
        }
      }

      &.view-more {
        padding-left: 0;
      }

      &,
      &:active {
        color: inherit;
      }

      &.subtitle {
        color: $textDarkModeDisabled;
        font-size: 12px;
        line-height: 18px;
        padding-top: 0;
        padding-bottom: 0;
        margin-bottom: 8px;
        letter-spacing: 0.5px;
      }

      svg,
      i.icon {
        margin-right: 8px;
        font-size: 16px;
        line-height: 16px;
        color: $textDarkModeHigh;
        transition: all 0.3s ease;
        position: relative;
        top: 1px;
      }

      &.dashboard {
        margin-bottom: 24px;
      }

      // &:not(:first-child) {
      //   padding-top: calc(16px + 5px);
      // }

      &:not(.subtitle):not(.disabled):not(.rl-active):hover {
        // border-left: 3px solid $dark2;
        svg,
        i.icon {
          color: $textDarkModeHigh;
        }
        .text-item {
          color: #fff;
        }
        background-color: #444545;
        cursor: pointer;
        // .tooltip {
        //   visibility: visible;
        //   opacity: 1;
        //   z-index: 101;
        // }
      }

      &__quick-add {
        i.typo-icon-12 {
          font-size: 18px;
          line-height: 18px;
          color: $light5;
        }
      }
      &:hover .nav-link__quick-add {
        display: flex;
      }
      &.rl-eactive,
      &.rl-active {
        svg,
        i.icon {
          color: #fff;
        }
        .text-item {
          color: #fff;
        }
        padding-left: 16px;
        background-color: #323232;
        cursor: pointer;
      }

      // &.rl-eactive {
      //   color: $cPrimary;
      //   // border-right: 2px solid $cPrimary;
      //   // width: calc(100% - 24px);
      // }

      &.open {
        .arrow {
          display: flex;
          align-items: center;
          margin-left: auto;

          i.icon {
            font-size: 12px;
            line-height: 12px;
            color: $black1;
            font-weight: 500;
          }
        }
      }

      // i.icon.icon-menu {
      //   transform: rotate(90deg);
      // }

      .badge {
        margin-left: 8px;
      }
    }

    .sub-nav {
      background-color: $grey5;
      padding: 5px 0 5px 20px;
      margin-top: 8px;
    }
  }

  &.collapsed {
    width: 80px;
    min-width: 80px;

    .logo {
      i {
        display: none;
      }
      padding-left: 20px;
    }

    .sidenav {
      // padding-top: 20px;

      .nav-link {
        padding-left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        &:not(.subtitle) > span {
          display: none;
        }

        &.subtitle {
          text-align: center;
          padding-left: 0;
          margin-top: 24px;
          padding: 0 8px;

          span {
            width: 100%;
          }
        }

        &:not(:first-child) {
          padding-top: calc(8px + 5px);
        }

        i.icon {
          margin-right: 0px;
          font-size: 26px;
        }

        &.dashboard {
          margin: 0;
        }
      }

      .pages {
        margin-bottom: 0;
      }

      .sub-nav {
        padding-left: 0px;
      }

      .help-center {
        .view-more {
          margin-top: 0;
        }

        .gp_dropdown {
          ::v-deep {
            .no-padding {
              padding: 0 0 0 24px;
            }

            .gp_dropdown_list {
              width: 200px;
              left: 10px;

              span {
                display: inline;
              }
            }
          }
        }
      }

      .acc-nav {
        margin: 0 0 16px 0;
      }
    }

    & + .gp-wrapper {
      margin-left: 80px;
    }

    ::v-deep .account-container {
      min-height: 36px;
      margin-bottom: 16px;

      .account {
        padding: 9px;
      }

      .name,
      .plan > span {
        display: none;
      }

      .upgrade > i.icon {
        margin: 0 4px !important;
      }
    }

    .toggler {
      width: 25px;
      padding-left: 8px;
    }
  }

  .toggler {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 12px;
    right: -25px;
    padding: 4px;
    height: 24px;
    width: 50px;
    padding-left: 28px;
    border-radius: 0px 5px 5px 0px;
    font-size: 14px;
    background: $dark3;
    color: $textDarkModeHigh;
    cursor: pointer;
    z-index: -1;
  }
}

.badge {
  display: flex;
  padding: 1px 5px;
  font-size: 10px;
  line-height: 10px;
  border-radius: 3px;
  min-width: 16px !important;
  min-height: 16px !important;
  justify-content: center;
  align-items: center;

  &-danger {
    background-color: $cRed;
    color: #fff;
  }
  &-warn {
    // background-color: ;
    border: 1px solid $accent-yellow;
    color: $accent-yellow;
  }

  &-instant {
    color: #fff;
    background-color: $cPrimary;
  }

  &-new {
    border: 1px solid $accent-green;
    color: $accent-green;
  }

  &-pro {
    background: $mono3;
    color: $light1;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
  }
}

.feedback-popover {
  display: flex;
  padding: 12px;
  position: absolute;
  width: 244px;
  height: 129px;
  left: 102%;
  color: $neutral5;
  background: $dark6;
  border-radius: 4px;
  &_action {
    @include trans-all;
    width: fit-content;
    padding: 7px 8px;
    border-radius: 3px;
    color: $textDarkModeHigh;
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
  &::after {
    content: "";
    position: absolute;
    right: 100%;
    top: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent $dark6 transparent transparent;
  }
}

.disabled .badge-warn .badge-new {
  opacity: 0.6;
}

.scrollBody {
  max-height: calc(100vh - 60px - 40px - 16px - 74px);
  padding-left: 8px;
  padding-right: 8px;
}

// trial se co them nut de upgrade nen can tinh lai max-height cho scrollBody theo cac breakpoint
.trial-plan {
  .scrollBody {
    max-height: calc(100vh - 60px - 40px - 16px - 120px);
  }
}

// starter cung co them nut de upgrade nen can tinh lai max-height cho scrollBody theo cac breakpoint
.starter-plan {
  .scrollBody {
    max-height: calc(100vh - 60px - 40px - 16px - 120px);
  }
}

@media screen and (min-width: 1440px) {
  .sidebar {
    min-width: 280px;
  }
}

@media screen and (max-width: 1439px) {
  .sidebar {
    min-width: 280px;
    width: 280px;
  }
}

@media screen and (max-width: 1279px) {
  .sidebar {
    width: 224px;
    min-width: 224px;
  }
}

@media screen and (max-width: 1023px) {
  .sidebar {
    ::v-deep .account-container {
      margin-bottom: 16px;
    }

    .sidenav .nav-link.subtitle {
      margin-top: 24px;
    }

    &:not(.collapsed) {
      .logo {
        justify-content: flex-start !important;
      }
    }
  }
}

@media screen and (max-height: 672px) {
  .sidebar {
    .sidenav {
      margin-top: 12px;
      .pages {
        margin-bottom: 16px;
      }
      .nav-link {
        &.subtitle {
          margin-bottom: 8px;
        }
        &.dashboard {
          margin-bottom: 16px;
        }
      }
    }

    .account-container {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }

    ::v-deep.account {
      .plan {
        margin-bottom: 12px;
      }
    }
  }

  .scrollBody {
    max-height: calc(100vh - 60px - 40px - 12px - 64px);
  }

  .trial-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 40px - 12px - 92px);
    }
  }

  .starter-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 40px - 12px - 102px);
    }
  }
}

@media screen and (max-height: 600px) {
  .sidebar {
    .sidenav {
      margin-top: 8px;
      .pages {
        margin-bottom: 8px;
      }
      .nav-link {
        padding-top: 8px;
        padding-bottom: 8px;
        &.subtitle {
          margin-bottom: 4px;
        }
        &.dashboard {
          margin-bottom: 8px;
        }
      }
    }

    ::v-deep.account {
      .plan {
        margin-bottom: 8px;
      }
    }
  }

  .scrollBody {
    max-height: calc(100vh - 60px - 35px - 8px - 70px);
  }

  .trial-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 35px - 8px - 80px);
    }
  }

  .starter-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 35px - 8px - 90px);
    }
  }
}
</style>
